class DocumentationPublishData {

    constructor() {

        this._documentType = null;

        this._id = null;
        this._icon = null;
        this._iconUrl = "";
        this._title = "";
        this._folderId = null;
        this._tags = [];
        this._description = "";
        this._date = "";
        this._time = "";
        this._extension = null;
        this._fileUrl = "";
        this._availableFolders = [];

        this._articleHtml = "";
        this._articleCover = "";
        this._articleTitle = "";

        this._externalContentHtml = "";
        this._externalContentUrl = "";
        this._externalContentLogo = "",
        this._externalContentName = "",
        this._externalContentDuration = null;
        this._externalContentMedia = "";
        this._externalContentHtmlCard = "";
        this._externalContentRel = [];
        this._externalContentThumbnail = null;

    }

    getDocumentType() {
        return this._documentType;
    }

    getDocumentId() {
        return this._id;
    }

    getDocumentIcon() {
        return this._icon;
    }

    getDocumentIconUrl() {
        return this._iconUrl;
    }

    getDocumentTitle() {
        return this._title;
    }

    getDocumentFolderId() {
        return this._folderId;
    }

    getDocumentTags() {
        return this._tags;
    }

    getDocumentDescription() {
        return this._description;
    }

    getDocumentDate() {
        return this._date;
    }

    getDocumentTime() {
        return this._time;
    }

    getDocumentExtension() {
        return this._extension;
    }

    getDocumentFileUrl() {
        return this._fileUrl;
    }

    getArticleDocumentHtml() {
        return this._articleHtml;
    }

    getArticleDocumentCover() {
        return this._articleCover;
    }

    getArticleDocumentTitle() {
        return this._articleTitle;
    }

    getExternalContentHtml() {
        return this._externalContentHtml;
    }

    getExternalContentUrl() {
        return this._externalContentUrl;
    }

    getExternalContentLogo() {
        return this._externalContentLogo;
    }

    getExternalContentName() {
        return this._externalContentName;
    }

    getExternalContentDuration() {
        return this._externalContentDuration;
    }

    getExternalContentMedia() {
        return this._externalContentMedia;
    }

    getExternalContentHtmlCard() {
        return this._externalContentHtmlCard;
    }

    getExternalContentRel() {
        return this._externalContentRel;
    }

    getExternalContentThumbnail() {
        return this._externalContentThumbnail;
    }

    getDocumentData(publishNow, programPublication, editingDraft, editingPublishedDocument, changedFileOnEdit) {

        const documentData = {
            world_token: world.token,
            folder_id: parseInt(this._folderId),
            extension: this._extension,
            name: this._title,
            tags: this._tags,
            document: this._fileUrl,
            is_published: editingPublishedDocument ? editingPublishedDocument : publishNow,
            uploaded: true
        };

        if (programPublication) {
            documentData.scheduled_at = formatDateTimeATOM(this._date, this._time);
        }

        if (this._description) {
            documentData.comment = this._description;
        }

        if (this._icon) {
            documentData.icon = this._icon;
        } else {
            documentData.icon_url = this._iconUrl;
        }

        if (editingDraft) {
            documentData.id = this._id;
            documentData.document = changedFileOnEdit ? this._fileUrl : null;
        }

        return documentData;

    }

    getArticleDocumentData(publishNow, programPublication, editingDraft, editingPublishedDocument) {

        const documentData = {
            world_token: world.token,
            folder_id: parseInt(this._folderId),
            extension: this._extension,
            name: this._title,
            tags: this._tags,
            document: this._fileUrl,
            is_published: editingPublishedDocument ? editingPublishedDocument : publishNow,
            html: this._articleHtml,
            article_cover: this._articleCover,
            article_title: this._articleTitle,
            uploaded: false,
        };

        if (programPublication) {
            documentData.scheduled_at = formatDateTimeATOM(this._date, this._time);
        }

        if (this._description) {
            documentData.comment = this._description;
        }

        if (this._icon) {
            documentData.icon = this._icon;
        } else {
            documentData.icon_url = this._iconUrl;
        }

        if (editingDraft) {
            documentData.id = this._id;
        }

        return documentData;

    }

    getExternalDocumentData(publishNow, programPublication, editingDraft, editingPublishedDocument) {

        const documentData = {
            world_token: world.token,
            folder_id: parseInt(this._folderId),
            title: this._title,
            url: this._externalContentUrl,
            site: {
                logo: this._externalContentLogo,
                name: this._externalContentName
            },
            media: this._externalContentMedia,
            document: this._externalContentHtml,
            is_published: editingPublishedDocument ? editingPublishedDocument : publishNow,
            tags: this._tags,
            rel: this._externalContentRel
        };

        if (programPublication) {
            documentData.scheduled_at = formatDateTimeATOM(this._date, this._time);
        }

        if (this._externalContentHtmlCard) {
            documentData.document_card = this._externalContentHtmlCard;
        }

        if (this._externalContentDuration) {
            documentData.duration = this._externalContentDuration;
        }

        if (this._description) {
            documentData.description = this._description;
        }

        if (this._icon) {
            documentData.icon = this._icon;
        } else {
            documentData.icon_url = this._iconUrl;
        }

        if (editingDraft) {
            documentData.id = this._id;
        }

        return documentData;

    }

    getAvailableFolders() {
        return this._availableFolders;
    }

    setDocumentType(documentType) {
        this._documentType = documentType;
    }

    setDocumentId(id) {
        this._id = id;
    }

    setDocumentIcon(icon) {
        this._icon = icon;
    }

    setDocumentIconUrl(iconUrl) {
        this._iconUrl = iconUrl;
    }

    setDocumentTitle(title) {
        this._title = title;
    }

    setDefaultDocumentTitle() {

        const documentationNew = documentationScreenController.documentationNew;

        switch(this._documentType) {

            case documentationNew.ARTICLE:
                this._title = Translator.trans("TR_NUEVO_ARTICULO");
                break;

            case documentationNew.DOCUMENT:
                this._title = Translator.trans("TR_NUEVO_DOCUMENTO");
                break;

            case documentationNew.IMAGE:
                this._title = Translator.trans("TR_NUEVA_IMAGEN");
                break;

            case documentationNew.VIDEO:
                this._title = Translator.trans("TR_NUEVO_VIDEO");
                break;

            case documentationNew.EXTERNAL:
                this._title = Translator.trans("TR_NUEVO_CONTENIDO_EXTERNO");
                break;

        }

    }

    setDocumentFolderId(folderId) {
        this._folderId = folderId;
    }

    setDocumentTags(tags) {
        this._tags = tags;
    }

    addDocumentTag(tag) {
        this._tags.push(tag);
    }

    removeDocumentTag(tag) {
        _.remove(this._tags, function(item) {
            return item === tag;
        });
    }

    setDocumentDescription(description) {
        this._description = description;
    }

    setDocumentDate(date) {
        this._date = date;
    }

    setDocumentTime(time) {
        this._time = time;
    }

    setDocumentExtension(extension) {
        this._extension = extension;
    }

    setDocumentFileUrl(fileUrl) {
        this._fileUrl = fileUrl;
    }

    setArticleDocumentData(html, cover, title) {

        this._articleHtml = html;
        this._articleCover = cover;
        this._articleTitle = title;

    }

    setExternalContentHtml(html) {
        this._externalContentHtml = html;
    }

    setExternalContentUrl(url) {
        this._externalContentUrl = url;
    }

    setExternalContentDuration(duration) {
        this._externalContentDuration = duration;
    }

    setExternalContentMedia(media) {
        this._externalContentMedia = media;
    }

    setExternalContentHtmlCard(htmlCard) {
        this._externalContentHtmlCard = htmlCard;
    }

    setExternalContentRel(rel) {
        this._externalContentRel = rel;
    }

    setExternalContentThumbnail(thumbnail) {
        this._externalContentThumbnail = thumbnail;
    }

    setExternalContentLogo(logo) {
        this._externalContentLogo = logo;
    }

    setExternalContentName(name) {
        this._externalContentName = name;
    }

    setExternalContentData(url, site, duration, media, document, documentCard, rel, thumbnail) {

        this._externalContentUrl = url;
        this._externalContentDuration = duration;
        this._externalContentLogo = site.logo;
        this._externalContentName = site.name;
        this._externalContentMedia = media;
        this._externalContentHtml = document;
        this._externalContentHtmlCard = documentCard;
        this._externalContentRel = rel;
        this._externalContentThumbnail = thumbnail;

    }

    setAvailableFolders(folders) {
        this._availableFolders = folders;
    }

}